import { get, post, Delete } from '../axios'

// 场景管理-列表
export const loadUserScenarioList = id => get(`/web/loadUserScenario/list/${id}`);

// 场景管理-详情
export const loadUserScenarioGet = id => get(`/web/loadUserScenario/get/${id}`);

// 场景管理-新增
export const loadUserScenarioAdd = params => post(`/web/loadUserScenario/add`, params);

// 场景管理-更新
export const loadUserScenarioUpdate = params => post(`/web/loadUserScenario/update`, params);

// 场景管理-删除（支持单个ID或逗号分隔的多个ID）
export const loadUserScenarioDelete = ids => Delete(`/web/loadUserScenario/delete/${ids}`);

//  拉取网关列表
export const gatewayListModelRelateGateway = params => get(`/web/modelAi/gateway/listModelRelateGateway`, params);

// 点击关联确认
export const gatewaySetRelateGateway = params => post(`/web/modelAi/setRelateGateway`, params);

// 移除网关关联
export const loadUserScenarioGateWayDelete = ids => Delete(`/web/modelAi/modelGateway/delete/${ids}`);
